export const isNationAMember = (email: string): boolean => {
  const splitEmail = email.split('@');
  if (splitEmail[1] === 'nation-a.com') {
    return true;
  }
  return false;
};
